var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.thisTab
    }
  }, [_c('v-layout', {
    staticClass: "h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "overflow": "hidden"
    }
  }, [_c('employment-doc-view', _vm._b({}, 'employment-doc-view', {
    value: _vm.fields,
    pages: _vm.pages,
    mode: 'view',
    hideZoom: true
  }, false))], 1), _c('v-divider'), _c('div', {
    staticClass: "v-btn-group flex-wrap my-12"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('exit');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("닫기")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('next');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 서명 시작 ")]), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }